import React, { createContext, useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useUser } from './UserProvider';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en'); // Default language is English
  const { user } = useUser();
  const { i18n } = useTranslation();

  useEffect(() => {
    // The user object from useUser() now contains the full user profile,
    // including preferredLanguage. We no longer need to fetch it here.
    if (user?.preferredLanguage) {
      const userLang = user.preferredLanguage;
      setLanguage(userLang);
      if (i18n.language !== userLang) {
        i18n.changeLanguage(userLang);
      }
    }
    // When user is null (logged out), we can decide if we want to reset the language.
    // For now, it will just keep the language of the last logged-in user.
  }, [user, i18n]);

  const updateLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    if (i18n.language !== newLanguage) {
      i18n.changeLanguage(newLanguage);
    }
  };

  const value = { language, setLanguage: updateLanguage };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);